import { Box } from '@mui/material';
import { ILockerGateItem } from 'api/interfaces/lockerGate';
import { StyledTenantName, StyledUnitNo } from '../../StyledComponents';
import { TENANT_BADGE_STATUSES } from '../StatusBadge';

export const RowItemHead = ({ tenantName, userFriendlyId, isLocker, lockerStatus }: ILockerGateItem) => {
	const maxLengthWithoutSpaces = 25;
	const itemNameLength = userFriendlyId ? userFriendlyId.length : 0;
	const tenantMaxLength = Math.max(0, maxLengthWithoutSpaces - itemNameLength);

	const truncatedTenantName = (() => {
		if (!tenantName || tenantMaxLength <= 0) {
			return undefined;
		}

		if (tenantName.length <= tenantMaxLength) {
			return tenantName;
		}

		if (tenantMaxLength <= 3) {
			return undefined;
		}

		return `${tenantName.slice(0, tenantMaxLength - 3)}...`;
	})();

	// Tenant name is shown inside the status badge for these statuses, so avoid duplicating it here.
	const showTenant = Boolean(
		isLocker && truncatedTenantName && (lockerStatus == null || !TENANT_BADGE_STATUSES.includes(lockerStatus))
	);

	return (
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexShrink: 0 }}>
			<StyledUnitNo title={userFriendlyId}>{userFriendlyId}</StyledUnitNo>
			{showTenant && <StyledTenantName title={tenantName}>({truncatedTenantName})</StyledTenantName>}
		</Box>
	);
};
